import LinearProgress from '@mui/material/LinearProgress';
import { createStyles, withStyles } from '@mui/styles';

export interface IOwnProps {
  percent: string;
  stage: string;
}

export type IProps = IOwnProps;

export const BorderLinearProgress = withStyles(() => createStyles({
  root: {
    height: 12,
    borderRadius: 6,
  },
  bar: {
    borderRadius: 5,
  },
}))(LinearProgress);
